export const CONTAINER_PADDING = "48px";
export const CONTENT_ITEM_BORDER_SIZE = "12px";
export const CONTENT_PLACEHOLDER_MARGIN = "32px";
export const CONTENT_PLACEHOLDER_GAP = "8px";
export const PAGE_GAP = "32px";
export const PAGE_MAX_WIDTH = "816px";
